// start:ng42.barrel
import './cca-available-dashboard.component';
// end:ng42.barrel

